import { Icon } from '@iconify/react'
import googleFill from '@iconify/icons-eva/google-fill'
import twitterFill from '@iconify/icons-eva/twitter-fill'
import facebookFill from '@iconify/icons-eva/facebook-fill'
import linkedinFill from '@iconify/icons-eva/linkedin-fill'
import { Link as ScrollLink } from 'react-scroll'
import { Link as RouterLink } from 'react-router-dom'
// material
import { experimentalStyled as styled } from '@material-ui/core/styles'
import {
  Grid,
  Link,
  Divider,
  Container,
  Typography,
  IconButton,
  Stack,
  Box,
} from '@material-ui/core'
// routes
import { PATH_PAGE } from '../../routes/paths'
import SkynicheLogo from '../../images/skyniche_logo.png'
//
import Logo from '../../components/Logo'

// ----------------------------------------------------------------------

const SOCIALS = [
  { name: 'FaceBook', icon: facebookFill },
  { name: 'Google', icon: googleFill },
  { name: 'Linkedin', icon: linkedinFill },
  { name: 'Twitter', icon: twitterFill },
]

const LINKS = [
  // {
  //   children: [
  //     {
  //       name: 'A passionate team of engineers focused on tools, design, manufacturing, and innovation.Combining experience and creativity to deliver quality solutions with precision and efficiency.',
  //       href: '#',
  //     },
  //   ],
  // },
  {
    headline: 'Information',
    children: [
      { name: 'Home', href: '/' },
      { name: 'Leadership Team', href: PATH_PAGE.leadershipteam },
      { name: 'Services', href: PATH_PAGE.services },
    ],
  },
  {
    headline: 'Feromach',
    children: [
      { name: 'Gallery', href: PATH_PAGE.gallery },
      { name: 'Contact us', href: PATH_PAGE.contact },
    ],
  },
  {
    headline: 'Contact',
    children: [
      { name: '+91 70341 30243', href: 'tel:+9197034130243' },
      { name: 'admin@feromach.com', href: 'mailto:admin@feromach.com' },
      {
        name: 'PLOT NO: KIIP-05,KINFRA Intergrated Industrial Park,Lakkidi Koottupatha, Palappuram P.O.,Ottapalam, Palakkad, Kerala-679 103.',
        href: '#',
      },
    ],
  },
]

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
  //
}))

export default function MainFooter() {
  return (
    <RootStyle>
      <Divider />
      <Container maxWidth="lg" sx={{ pt: 6 }}>
        {/* <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 3 }}
        >
          <Grid item>
            <ScrollLink to="move_top" spy smooth>
              <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
            </ScrollLink>
            <Typography variant="body2" sx={{ maxWidth: '260px', mt: 3.5 }}>
              A passionate team of engineers focused on tools, design,
              manufacturing, and innovation.Combining experience and creativity
              to deliver quality solutions with precision and efficiency.
            </Typography>
          </Grid>

          <Grid item>
            <Stack spacing={1.5} direction="row" justifyContent="flex-end">
              {SOCIALS.map((social) => (
                <IconButton key={social.name} color="primary" sx={{ p: 1 }}>
                  <Icon icon={social.icon} width={25} height={30} />
                </IconButton>
              ))}
            </Stack>
          </Grid>
        </Grid> */}
        {/* <Divider sx={{ my: 3 }} /> */}
        <Grid
          container
          spacing={3}
          justifyContent={{ xs: 'flex-start', md: 'space-between' }}
          sx={{ textAlign: { xs: 'left', md: 'left' } }}
        >
          {LINKS.map((list) => {
            const { headline, children } = list
            return (
              <Grid item xs={12} sm={12} md={3} key={headline}>
                <Stack spacing={2}>
                  <Typography component="p" variant="overline">
                    {headline}
                  </Typography>

                  {children.map((link) => (
                    <>
                      <Link
                        key={link.name}
                        color="inherit"
                        variant="body2"
                        href={
                          link.href.startsWith('mailto:') ||
                          link.href.startsWith('http') ||
                          link.href.startsWith('tel:')
                            ? link.href
                            : undefined
                        }
                        to={
                          !link.href.startsWith('mailto:') &&
                          !link.href.startsWith('http') &&
                          !link.href.startsWith('tel:')
                            ? link.href
                            : undefined
                        }
                        component={
                          link.href.startsWith('mailto:') ||
                          link.href.startsWith('http') ||
                          link.href.startsWith('tel:')
                            ? 'a'
                            : RouterLink
                        }
                        sx={{
                          display: 'block',
                          mr: link.name.includes(
                            'A passionate team of engineers',
                          )
                            ? '20px'
                            : '0px',
                          textDecoration: link.name.includes('PLOT NO')
                            ? 'none !important'
                            : 'none',
                          '&:hover': {
                            textDecoration: link.name.includes('PLOT NO')
                              ? 'none'
                              : 'underline',
                          },
                        }}
                      >
                        {link.name}
                      </Link>

                      {/* {link.name.includes('PLOT NO') && (
                        <ScrollLink to="move_top" spy smooth>
                          <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
                        </ScrollLink>
                      )} */}
                    </>
                  ))}
                </Stack>
              </Grid>
            )
          })}
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ py: 2 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap', 
            gap: 1.5,
          }}
        >
          <a
            href="https://www.skyniche.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              color: 'inherit',
              
            }}
          >
            <img
              src={SkynicheLogo}
              alt="Skyniche Logo"
              style={{ height: 20 }}
            />
            <Typography
              variant="body2"
              sx={{
                fontSize: 13,
                whiteSpace: 'nowrap',
                ml: 0.5,
                fontWeight: 'bold',
              }}
            >
              A skyniche Production 
            </Typography>
          </a>

          {/* Separator or spacing */}
          <Typography variant="body2" sx={{ fontSize: 13 }}>
            |
          </Typography>

          {/* Copyright */}
          <Typography
            variant="body2"
            sx={{
              fontSize: 13,
              whiteSpace: 'nowrap',
            }}
          >
            © {new Date().getFullYear()}. All rights reserved.
          </Typography>
        </Box>
      </Box>
        <Box
          sx={{
            display: { xs: 'flex', md: 'none' },
            justifyContent: 'center',
            mt: 1,
            mb: 3,
          }}
        >
          <Stack direction="row" spacing={2}>
            {SOCIALS.map((social) => (
              <IconButton key={social.name} color="primary" sx={{ p: 1 }}>
                <Icon icon={social.icon} width={25} height={30} />
              </IconButton>
            ))}
          </Stack>
        </Box>
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            justifyContent: 'flex-end',
            position: 'absolute',
            right: 65,
            bottom: 5,
            // mb: -2,
          }}
        >
          <Stack direction="row" spacing={2}>
            {SOCIALS.map((social) => (
              <IconButton key={social.name} color="primary" sx={{ p: 1 }}>
                <Icon icon={social.icon} width={25} height={30} />
              </IconButton>
            ))}
          </Stack>
        </Box>
      </Container>
    </RootStyle>
  )
}
